import '../../lib/version';
import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import qs from 'qs';
import Axios from 'axios';
import Appoint from './appoint';

moment.locale('ja', {
  week: {
    dow: 1,
    doy: 1
  },
  weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
});

Axios.interceptors.request.use(
  config => {
    if (['post', 'put', 'patch', 'delete'].includes(config.method ?? '') && config.headers) {
      const csrf = document?.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
      if (csrf) {
        config.headers['X-CSRF-Token'] = csrf;
      }
    }
    config.paramsSerializer = (prms: any) => qs.stringify(prms);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<Appoint />, document.body.appendChild(document.createElement('div')));
});
